/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".customer-switcher__mobile[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{left:30px;width:229.5px}.customer-switcher__mobile[_ngcontent-%COMP%]   .dropdown-item[_ngcontent-%COMP%]{text-align:left;padding-left:0;padding-right:0;overflow:hidden}"];
export { styles as styles };
